/**
 * Organisation Domain
 */

export enum Location {
  Chatswood = 'Chatswood',
}

export const LOCATION_LABELS: Record<Location, string> = {
  [Location.Chatswood]: 'Chatswood',
};

export enum Grade {
  HSC = 'hsc',
  Prelim = 'prelim',
}

export const GRADE_LABELS: Record<Grade, string> = {
  [Grade.HSC]: 'HSC',
  [Grade.Prelim]: 'Prelim',
};

export enum Subject {
  Chemistry = 'chem',
  Physics = 'phys',
  MathsExt1 = 'mtx1',
  MathsExt2 = 'mtx2',
}

export enum SubjectLabel {
  Chemistry = 'Chemistry',
  Physics = 'Physics',
  MathsExt1 = 'Maths Ext 1',
  MathsExt2 = 'Maths Ext 2',
}

export const SUBJECT_LABELS: Record<Subject, SubjectLabel> = {
  [Subject.Chemistry]: SubjectLabel.Chemistry,
  [Subject.Physics]: SubjectLabel.Physics,
  [Subject.MathsExt1]: SubjectLabel.MathsExt1,
  [Subject.MathsExt2]: SubjectLabel.MathsExt2,
};

export enum UserGroup {
  Admins = 'Admins',
  Managers = 'Managers',
  Owners = 'Owners',
  Teachers = 'Teachers',
  Students = 'Students',
  BillingOfficers = 'BillingOfficers',
  PayrollOfficers = 'PayrollOfficers',
  ShiftManagers = 'ShiftManagers',
  CourseManagers = 'CourseManagers',
  CourseDevelopers = 'CourseDevelopers',
}

export const USER_GROUP_LABELS: Record<UserGroup, string> = {
  [UserGroup.Admins]: 'Admin',
  [UserGroup.Managers]: 'Manager',
  [UserGroup.Owners]: 'Owner',
  [UserGroup.Teachers]: 'Teacher',
  [UserGroup.Students]: 'Student',
  [UserGroup.BillingOfficers]: 'Billing officer',
  [UserGroup.PayrollOfficers]: 'Payroll officer',
  [UserGroup.ShiftManagers]: 'Shift manager',
  [UserGroup.CourseManagers]: 'Course manager',
  [UserGroup.CourseDevelopers]: 'Course developer',
};

export enum UserType {
  Student = 'STUDENT',
  Staff = 'STAFF',
}

export enum LeadType {
  Enrolment = 'ENROLMENT',
  Contact = 'CONTACT',
}

export const LEAD_TYPE_LABELS: Record<LeadType, string> = {
  [LeadType.Enrolment]: 'Enrolment',
  [LeadType.Contact]: 'Contact',
};

export enum EnrolmentMethod {
  Class = 'CLASS',
  Makeup = 'MAKEUP',
  OneOff = 'ONEOFF',
}

export const ENROLMENT_METHOD_LABELS: Record<EnrolmentMethod, string> = {
  [EnrolmentMethod.Class]: 'Class',
  [EnrolmentMethod.Makeup]: 'Makeup',
  [EnrolmentMethod.OneOff]: 'One-off',
};

/**
 * Xero & Billing
 */

export enum XeroDepartment {
  Chemistry = 'Chemistry',
  Physics = 'Physics',
  Mathematics = 'Mathematics',
}

export enum XeroLineItemCode {
  Meta = 'META',
  SpecialDiscount = 'SD',
}

export enum BillingType {
  Term = 'TERM',
  Extra = 'EXTRA',
}

export const BILLING_TYPE_LABELS: Record<BillingType, string> = {
  [BillingType.Term]: 'Term',
  [BillingType.Extra]: 'Extra',
};

export enum CreditType {
  Credit = 'CREDIT',
}

/**
 * Application Settings
 */

export enum ThemeMode {
  Light = 'light',
  Dark = 'dark',
}

/**
 * Exam Marking (Shared)
 */

export enum LegacyExamAttemptType {
  LegacyExam = 'EXAM',
  Question = 'QUESTION',
}

export enum LegacyExamAttemptStatus {
  MarkingInProgress = 'MARKING_IN_PROGRESS',
  Marked = 'MARKED',
}
